import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
/**
 * Layout gridtitle element, used for each individual gridtitle
 *
 * @prop {String} title - mandatory, used to display the desired title
 * @prop {String} fontSize - mandatory, use to define the fontsize
 * @prop {String} showLine - optional, used to show a line underneath the title
 * @prop {String} rowStart - mandatory, used to define the position of this element
 * @prop {String} rowEnd - mandatory, used to define the position of this element
 * @prop {String} columnStart - mandatory, used to define the position of this element
 * @prop {String} columnEnd - mandatory, used to define the position of this element
 * @prop {String} subtitle - optional, used to display the desired subtitle
 * @prop {Boolean} light - optional, used to display the title and subtitle in white color


 *
 */
let SDBLayoutGridTitle = class SDBLayoutGridTitle extends LitElement {
    constructor() {
        super(...arguments);
        this.title = '';
        this.subtitle = '';
        this.fontSize = '';
        this.showLine = false;
        this.columnStart = '';
        this.columnEnd = '';
        this.rowStart = '';
        this.rowEnd = '';
    }
    render() {
        return html `
            <div
                id="gridTitle"
                style="
        grid-column-start:${this.columnStart};
        grid-column-end:${this.columnEnd};
        grid-row-start:${this.rowStart};
        grid-row-end:${this.rowEnd};
        font-size:${this.fontSize};"
            >
                <span class="title" part="title">${this.title}</span>
                ${this.subtitle
            ? html `<span class="subtitle" part="subtitle"
                          >${this.subtitle}</span
                      >`
            : html ``}
            </div>
        `;
    }
};
SDBLayoutGridTitle.styles = [
    elements,
    css `
            :host {
                display: contents;
            }

            :host([light]) #gridTitle > span {
                color: var(--text-light);
            }

            :host #gridTitle {
                display: block;
                width: 100%;
                min-height: 25px;
                height: auto;
                line-height: 1em;
                color: var(--sdb-layout-gridtitle-color, --text-primary);
                margin-top: 30px;
            }

            :host([showLine]) #gridTitle {
                border-top: 1px solid rgba(0, 0, 0, 0.1);
                padding-top: 10px;
            }

            .title,
            .subtitle {
                display: block;
                width: auto;
            }

            .subtitle {
                font-size: 0.95em;
                font-weight: 300;
                margin: 5px 0;
            }
        `,
];
__decorate([
    property({ type: String })
], SDBLayoutGridTitle.prototype, "title", void 0);
__decorate([
    property({ type: String })
], SDBLayoutGridTitle.prototype, "subtitle", void 0);
__decorate([
    property({ type: String })
], SDBLayoutGridTitle.prototype, "fontSize", void 0);
__decorate([
    property({ type: Boolean })
], SDBLayoutGridTitle.prototype, "showLine", void 0);
__decorate([
    property({ type: String })
], SDBLayoutGridTitle.prototype, "columnStart", void 0);
__decorate([
    property({ type: String })
], SDBLayoutGridTitle.prototype, "columnEnd", void 0);
__decorate([
    property({ type: String })
], SDBLayoutGridTitle.prototype, "rowStart", void 0);
__decorate([
    property({ type: String })
], SDBLayoutGridTitle.prototype, "rowEnd", void 0);
SDBLayoutGridTitle = __decorate([
    customElement('sdb-layout-gridtitle')
], SDBLayoutGridTitle);
export { SDBLayoutGridTitle };
//# sourceMappingURL=sdb-layout-gridtitle.js.map